import FullscreenButton from '@atlassian/jira-fullscreen-button';

export default FullscreenButton;
